import React from 'react';
import { getAvatarPlanetRgb } from '../../data/avatarPlanetGlow';

/**
 * Planet-colored revolving smoke aura around a circular avatar portrait.
 * @param {Object} props
 * @param {string | null | undefined} [props.avatarId]
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children
 */
export function AvatarPlanetGlow({ avatarId, className = '', children }) {
  const rgb = getAvatarPlanetRgb(avatarId);

  return (
    <span
      className={`avatar-planet-glow ${className}`.trim()}
      style={{ '--avatar-glow-rgb': rgb }}
    >
      <span className="avatar-planet-glow__smoke avatar-planet-glow__smoke--outer" aria-hidden />
      <span className="avatar-planet-glow__smoke avatar-planet-glow__smoke--mid" aria-hidden />
      <span className="avatar-planet-glow__smoke avatar-planet-glow__smoke--inner" aria-hidden />
      <span className="avatar-planet-glow__haze" aria-hidden />
      <span className="avatar-planet-glow__content">{children}</span>
    </span>
  );
}
